import { NODE_ENV } from "@/utils/config"

const state = {
  drawer: null,
  color:
    NODE_ENV === "development"
      ? "blue"
      : NODE_ENV === "staging"
      ? "green"
      : "blue",
  image: "public/img/background-drawer-jpg",
}

export default {
  state,
}
